import React from 'react';
import { Button } from '../ui/button';
import { Badge } from '../ui/badge';
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from '../ui/table';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '../ui/card';
import { MessageSquare, Video, Mail, Phone } from 'lucide-react';
import { useTranslation } from 'react-i18next';

const SellerInteractionsTab = ({ interactions, getStatusBadge, startVideoCall, joinExistingCall, endVideoCall, updateInteractionStatus }) => {
  const { t } = useTranslation();

  return (
    <Card>
      <CardHeader>
        <CardTitle>{t('dashboard.attendee_interactions')}</CardTitle>
        <CardDescription>{t('dashboard.attendee_interactions_desc')}</CardDescription>
      </CardHeader>
      <CardContent>
        {interactions.length === 0 ? (
          <div className="text-center py-8">
            <MessageSquare className="h-12 w-12 text-slate-400 mx-auto mb-4" />
            <p className="text-slate-600">{t('dashboard.no_interactions')}</p>
          </div>
        ) : (
          <Table>
            <TableHeader>
              <TableRow>
                <TableHead>{t('dashboard.attendee')}</TableHead>
                <TableHead>{t('dashboard.company')}</TableHead>
                <TableHead>{t('dashboard.type')}</TableHead>
                <TableHead>{t('dashboard.status')}</TableHead>
                <TableHead>{t('dashboard.message')}</TableHead>
                <TableHead>{t('dashboard.actions')}</TableHead>
              </TableRow>
            </TableHeader>
            <TableBody>
              {[...interactions].sort((a, b) => new Date(b.updated_at || b.created_at) - new Date(a.updated_at || a.created_at)).map((interaction) => (
                <TableRow key={interaction.id}>
                  <TableCell>
                    <div><p className="font-medium">{interaction.buyer_name}</p><p className="text-sm text-slate-500">{interaction.buyer_email}</p></div>
                  </TableCell>
                  <TableCell>{interaction.buyer_company || '-'}</TableCell>
                  <TableCell>
                    {interaction.interaction_type === 'call_request' ? (
                      <Badge className="bg-blue-100 text-blue-700"><Video className="h-3 w-3 mr-1" />Call</Badge>
                    ) : (
                      <Badge className="bg-purple-100 text-purple-700"><Mail className="h-3 w-3 mr-1" />Email</Badge>
                    )}
                  </TableCell>
                  <TableCell>{getStatusBadge(interaction.status)}</TableCell>
                  <TableCell className="max-w-xs truncate">{interaction.message || '-'}</TableCell>
                  <TableCell>
                    <div className="flex gap-1">
                      {interaction.status === 'in_queue' && interaction.interaction_type === 'call_request' && (
                        <Button size="sm" variant="default" onClick={() => startVideoCall(interaction)}><Video className="h-4 w-4 mr-1" /> Start Call</Button>
                      )}
                      {interaction.status === 'on_call' && interaction.interaction_type === 'call_request' && (
                        <>
                          <Button size="sm" variant="outline" onClick={() => joinExistingCall(interaction)}><Phone className="h-4 w-4 mr-1" /> Join</Button>
                          <Button size="sm" variant="destructive" onClick={() => endVideoCall()}>End Call</Button>
                        </>
                      )}
                      {interaction.status === 'email_sent' && (
                        <Button size="sm" variant="outline" onClick={() => updateInteractionStatus(interaction.id, 'email_responded')}>Mark Responded</Button>
                      )}
                    </div>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        )}
      </CardContent>
    </Card>
  );
};

export default SellerInteractionsTab;
